import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableHeaderCell,
  Text,
  Capitalize,
  H2
} from '../../../../../components';

import { termTranslationShape } from '../../../../../propsShape';

const TermTranslationsContainer = styled.div`
  padding: 0px 24px 24px 24px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
`;

const TermTranslationsTable = styled(Table)`
  table-layout: fixed;
  border-collapse: collapse;
`;

const TermHeaderCell = styled(TableHeaderCell)`
  width: 25%;
`;
const DefinitionHeaderCell = styled(TableHeaderCell)`
  width: auto;
`;

const BaseCell = styled(TableCell)`
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;
const TermCell = styled(BaseCell)`
  width: 25%;
`;
const DefinitionCell = styled(BaseCell)`
  width: auto;
`;

const StyledH2 = styled(H2)`
  margin-bottom: 24px;
`;

const DataDictionaryTermTranslationsView = ({ termTranslations }) => (
  <TermTranslationsContainer>
    <StyledH2>Business logic</StyledH2>
    <TermTranslationsTable>
      <TableHead>
        <TableRow>
          <TermHeaderCell>
            <Text as='span' $bold $color='var(--content-subtitle)'>
              Term
            </Text>
          </TermHeaderCell>
          <DefinitionHeaderCell>
            <Text as='span' $bold $color='var(--content-subtitle)'>
              Definition
            </Text>
          </DefinitionHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {termTranslations.map(({ id, termList, displayedDescription }) => (
          <TableRow key={id}>
            <TermCell>
              {termList.map((term) => (
                <React.Fragment key={term}>
                  <Text as='span' $bold>
                    <Capitalize string={term} />
                  </Text>
                  <br />
                </React.Fragment>
              ))}
            </TermCell>
            <DefinitionCell>
              <Text as='span'>
                <Capitalize string={displayedDescription} />
              </Text>
            </DefinitionCell>
          </TableRow>
        ))}
      </TableBody>
    </TermTranslationsTable>
  </TermTranslationsContainer>
);

DataDictionaryTermTranslationsView.propTypes = {
  termTranslations: PropTypes.arrayOf(termTranslationShape).isRequired
};

export { DataDictionaryTermTranslationsView };
